import React from "react";
import { Link } from "react-router-dom";
import {
  EnvelopeSimple,
  LinkedinLogo,
  TwitterLogo,
} from "@phosphor-icons/react";
import logo from "../../assets/logo-white.png";

const footerLinks = {
  solutions: [
    { label: "Insurance Rail", href: "/rails/insurance" },
    { label: "Wallet Pool Management", href: "/rails/wallet-pool" },
    { label: "Reimbursement Rail", href: "/rails/reimbursement" },
    { label: "Zero Budget Access", href: "/rails/zero-budget" },
    { label: "Health Credit Facility", href: "/rails/health-credit" },
    { label: "Wellness and Preventive", href: "/rails/wellness" },
  ],
  calculators: [
    { label: "Design Your Plan", href: "/design-your-plan" },
    { label: "Quick Cost Estimator", href: "/calculators/quick" },
    { label: "Advanced Calculator", href: "/calculators/advanced" },
    { label: "Insurance Premium Estimator", href: "/calculators/insurance" },
  ],
  company: [
    { label: "About Us", href: "/#about" },
    { label: "Contact", href: "/#contact" },
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
  ],
};

export function Footer() {
  return (
    <footer className="bg-[#0A1128] text-white">
      <div className="container-full py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-2">
              <img
                src={logo}
                alt="Mentor Health"
                className="text-white font-bold text-lg w-28"
              />
            </Link>
            <p className="text-white/60 mb-6 max-w-sm">
              Health Fintech Infrastructure as a Service. One platform to
              finance, govern, and optimize employee healthcare benefits.
            </p>
            <div className="space-y-3">
              <a
                href="mailto:corporatebusiness@thementorhealth.com"
                className="flex items-center gap-3 text-white/60 hover:text-[#0048ff] transition-colors"
              >
                <EnvelopeSimple size={20} weight="light" />
                corporatebusiness@thementorhealth.com
              </a>
            </div>
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#0048ff] transition-colors"
              >
                <LinkedinLogo size={20} weight="light" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[#0048ff] transition-colors"
              >
                <TwitterLogo size={20} weight="light" />
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="font-semibold mb-4">Solutions</h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-[#0048ff] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Calculators */}
          <div>
            <h4 className="font-semibold mb-4">Calculators</h4>
            <ul className="space-y-3">
              {footerLinks.calculators.map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-[#0048ff] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, idx) => (
                <li key={idx}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-[#0048ff] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            {new Date().getFullYear()} Mentor Health. All rights reserved.
          </p>
          <p className="text-white/40 text-sm">
            Built in Singapore. Operational across Pakistan, UAE, USA
          </p>
        </div>
      </div>
    </footer>
  );
}
